export default "__VITE_ASSET__C4NGmzjr__"